import { render, staticRenderFns } from "./SitesView.vue?vue&type=template&id=8182707a&"
import script from "./SitesView.vue?vue&type=script&lang=js&"
export * from "./SitesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports